module.exports = __webpack_public_path__ + "static/Acropolis-ce5695f2468d66633fba2e8417c43d80.png";